/**
 * URL tabanlı sidebar aktif durumu.
 * @param {string} currentPath
 * @param {string} itemPath
 * @param {{ homePath?: string }} options — homePath alt rotaları aktif saymaz (örn. /dashboard)
 */
export function isPathActive(currentPath, itemPath, options = {}) {
  const { homePath } = options;
  if (currentPath === itemPath) return true;
  if (homePath && itemPath === homePath) return false;
  if (currentPath.startsWith(`${itemPath}/`)) return true;
  return false;
}

/**
 * Nav item görünürlük filtresi — config'teki `visible` bayrağını uygular.
 * @param {Array<{ id: string, items: Array<{ visible?: boolean }> }>} sections
 */
export function filterNavSections(sections) {
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => item.visible !== false),
    }))
    .filter((section) => section.items.length > 0);
}

/**
 * Mevcut path'e göre aktif nav item id'sini bulur.
 */
export function getActiveNavItemId(sections, currentPath, options = {}) {
  for (const section of sections) {
    for (const item of section.items) {
      if (isPathActive(currentPath, item.path, options)) {
        return item.id;
      }
    }
  }
  return null;
}
